import { render, staticRenderFns } from "./DistintaDettaglio.vue?vue&type=template&id=71c8cc29&scoped=true"
import script from "./DistintaDettaglio.vue?vue&type=script&lang=ts"
export * from "./DistintaDettaglio.vue?vue&type=script&lang=ts"
import style0 from "./DistintaDettaglio.vue?vue&type=style&index=0&id=71c8cc29&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8cc29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c8cc29')) {
      api.createRecord('71c8cc29', component.options)
    } else {
      api.reload('71c8cc29', component.options)
    }
    module.hot.accept("./DistintaDettaglio.vue?vue&type=template&id=71c8cc29&scoped=true", function () {
      api.rerender('71c8cc29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DistintaDettaglio.vue"
export default component.exports